import { trackAdView } from '../utils/omnitureTracking';
export const BUS_SEO_AD_CONTEXT_ID = 'QlVTI1NFTyNCT0RZ';
export const config = {
  userCallbackForView: contextId => {
    const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
    trackAdView(
      isMobileDevice
        ? `Mobile_Bus_SEO_Template_Ad_${contextId}_Viewed`
        : `Desktop_Bus_SEO_Template_Ad_${contextId}_Viewed`
    );
  },

  ORG: 'MMT',
  AUTH_COOKIE_KEY: 'mmt-auth',
  mode: 'PROD',
  API_CALL: 'SINGLE'
};
